module.exports = __webpack_public_path__ + "img/icon-dashboard-enable.bef21fb5.svg";